import clsx from "clsx";
import React, { FunctionComponent, SVGProps } from "react";

export const PartNumberIcon: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => {
  return (
    <svg
      {...props}
      className={clsx("tw-icon", className)}
      fill="none"
      height="24"
      viewBox="0 0 25 25"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M.25 2.875a.75.75 0 0 1 .75-.75h4.688a.75.75 0 0 1 0 1.5H1.75v3.938a.75.75 0 0 1-1.5 0V2.875Zm17.813 0a.75.75 0 0 1 .75-.75H23.5a.75.75 0 0 1 .75.75v4.688a.75.75 0 0 1-1.5 0V3.624h-3.938a.75.75 0 0 1-.75-.75ZM6.624 6.813a.75.75 0 0 1 .75.75v9.375a.75.75 0 0 1-1.5 0V7.563a.75.75 0 0 1 .75-.75Zm3.75 0a.75.75 0 0 1 .75.75v9.375a.75.75 0 0 1-1.5 0V7.563a.75.75 0 0 1 .75-.75Zm3.75 0a.75.75 0 0 1 .75.75v9.375a.75.75 0 0 1-1.5 0V7.563a.75.75 0 0 1 .75-.75Zm3.75 0a.75.75 0 0 1 .75.75v9.375a.75.75 0 0 1-1.5 0V7.563a.75.75 0 0 1 .75-.75ZM1 16.188a.75.75 0 0 1 .75.75v3.937h3.938a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1-.75-.75v-4.688a.75.75 0 0 1 .75-.75Zm22.5 0a.75.75 0 0 1 .75.75v4.687a.75.75 0 0 1-.75.75h-4.688a.75.75 0 0 1 0-1.5h3.938v-3.938a.75.75 0 0 1 .75-.75Z"
        fillRule="evenodd"
      />
    </svg>
  );
};
